module.exports = __webpack_public_path__ + "media/images/Visa-f694b4b579e7b61889bc760d05c2272e.svg";